var _rect, _path, _path2, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_182",
    "data-name": "Ret\\xE2ngulo 182",
    width: 58,
    height: 58,
    rx: 10,
    fill: "#fff595",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calendar-8",
    transform: "translate(13.348 11.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_200-2",
    "data-name": "Line 200-2",
    transform: "translate(0.155 12.354)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_357",
    "data-name": "Caminho 357",
    d: "M719.562,548.088h-29.74a1.251,1.251,0,0,1,0-2.5h29.74a1.251,1.251,0,0,1,0,2.5Z",
    transform: "translate(-688.57 -545.585)",
    fill: "#fff595"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Combined_Shape-29",
    "data-name": "Combined Shape-29",
    transform: "translate(7.612 18.871)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_358",
    "data-name": "Caminho 358",
    d: "M709.12,558.479a1.259,1.259,0,0,1-1.26-1.251,1.246,1.246,0,0,1,1.245-1.251h.015a1.251,1.251,0,1,1,0,2.5Zm-7.4,0a1.259,1.259,0,0,1-1.26-1.251,1.245,1.245,0,0,1,1.243-1.251h.017a1.251,1.251,0,0,1,0,2.5Zm-7.422,0a1.251,1.251,0,1,1-.013-2.5h.013a1.251,1.251,0,1,1,0,2.5Zm14.823-6.486a1.259,1.259,0,0,1-1.26-1.251,1.246,1.246,0,0,1,1.245-1.251h.015a1.251,1.251,0,1,1,0,2.5Zm-7.4,0a1.259,1.259,0,0,1-1.26-1.251,1.245,1.245,0,0,1,1.243-1.251h.017a1.251,1.251,0,0,1,0,2.5Zm-7.422,0a1.251,1.251,0,1,1-.013-2.5h.013a1.251,1.251,0,1,1,0,2.5Z",
    transform: "translate(-693.039 -549.491)",
    fill: "#fff595"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line_207-2",
    "data-name": "Line 207-2",
    transform: "translate(21.765 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_359",
    "data-name": "Caminho 359",
    d: "M702.772,546.175a1.252,1.252,0,0,1-1.251-1.251v-5.491a1.251,1.251,0,1,1,2.5,0v5.491A1.252,1.252,0,0,1,702.772,546.175Z",
    transform: "translate(-701.521 -538.181)",
    fill: "#fff595"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Line_208-2",
    "data-name": "Line 208-2",
    transform: "translate(8.284 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_360",
    "data-name": "Caminho 360",
    d: "M694.693,546.175a1.252,1.252,0,0,1-1.251-1.251v-5.491a1.251,1.251,0,1,1,2.5,0v5.491A1.252,1.252,0,0,1,694.693,546.175Z",
    transform: "translate(-693.442 -538.181)",
    fill: "#fff595"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Path-12",
    transform: "translate(0 2.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_361",
    "data-name": "Caminho 361",
    d: "M711.8,573H697.687c-5.681,0-9.21-3.5-9.21-9.14v-15.1c0-5.551,3.529-9,9.21-9h14.128a9.375,9.375,0,0,1,6.821,2.468,8.962,8.962,0,0,1,2.378,6.534v15.224C721.014,569.545,717.485,573,711.8,573Zm-14.113-30.737c-4.325,0-6.708,2.308-6.708,6.5v15.1c0,4.281,2.383,6.638,6.708,6.638H711.8c4.328,0,6.711-2.313,6.711-6.511V548.759A6.447,6.447,0,0,0,716.864,544a6.949,6.949,0,0,0-5.049-1.734Z",
    transform: "translate(-688.477 -539.76)",
    fill: "#fff595"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.9a1517f9c970fadee2e5f05e895597d4.svg";
export { ForwardRef as ReactComponent };